import { ActionTypes } from './actionTypes';
import { AppDispatch } from '../store';
import { createAction } from '../actions';
import { FilterBarFieldsData } from '../../components/filterbar';
import { HelpdeskFilterBarFieldsData } from '../../helpdesk-app/components/helpdesk-filterbar';

export const clearFilters = () => async (dispatch: AppDispatch) => {
  dispatch(createAction(ActionTypes.SET_FILTER, {} as FilterBarFieldsData));
  dispatch(createAction(ActionTypes.SET_HELPDESK_FILTER, {} as HelpdeskFilterBarFieldsData));
};

export const setFilters = (data: FilterBarFieldsData) => async (dispatch: AppDispatch) => {
  dispatch(createAction(ActionTypes.SET_FILTER, data));
};

export const setHelpDeskFilters = (data: HelpdeskFilterBarFieldsData) => async (dispatch: AppDispatch) => {
  dispatch(createAction(ActionTypes.SET_HELPDESK_FILTER, data));
};
